module.exports = __webpack_public_path__ + "static/img/404.2334c3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/404.png
// module id = tws9
// module chunks = 0